module.exports = __webpack_public_path__ + "img/poweredbyresonate.fb8d242c.svg";